import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../services/storage/local-storage.service';

/**
 * The guard checks for the presence of an invitation code in the query parameters or a flag in local storage indicating that the user has chosen to skip the welcome page. If either condition is met, the guard allows access to the requested route. Otherwise, it redirects the user to the welcome page.
 *
 * @param route
 * @returns
 */
export const welcomePageGuard: CanActivateFn = route => {
  const storageService = inject(LocalStorageService);
  const router = inject(Router);
  const { invitationCode } = route.queryParams;
  const skipWelcomePage = invitationCode || storageService.getItem('skipWelcomePage');

  if (skipWelcomePage) {
    return true;
  } else {
    return new RedirectCommand(router.parseUrl('welcome'));
  }
};
